import { render, staticRenderFns } from "./expand.vue?vue&type=template&id=b65ab696&"
import script from "./expand.vue?vue&type=script&lang=js&"
export * from "./expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports